import { AltroSoggetto } from './altro-soggetto';
import { Model } from './model';
import { User } from './user';

export class Filiale extends Model {
  static apiUrl: string = "filiali";

  nome: string;
  users?: User[];

  deserialize(input: any): Filiale {
    let retV: Filiale = new Filiale();
    retV = super.deserialize(input) as Filiale;

    if (input) {
      if (input?.users)
        this.users = input.users.map(u => new User().deserialize(u));
    }

    return retV;
  }


}
